"use client";
import "./CostInIndia.scss";
import Image from "next/image";
import AnimateHeight from "react-animate-height";
import { useState } from "react";

export default function CostInIndia({ name, costInfo, country = "India" }) {
  const [height, setHeight] = useState(340);
  return (
    <div className="costInIndiaWrapper">
      <p className="costInIndiaHeading">
        <span className="costInIndiaBoldHeading">
          Cost of {name} treatment in different cities
        </span>{" "}
        in {country}
      </p>

      <AnimateHeight
        style={{ width: "100%" }}
        id="example-panel"
        duration={500}
      >
        <div className="costsWrapper">
          {costInfo.map((item, i) => {
            return (
              <div className="costsContainer" key={i}>
                <div className="costName">
                  <p className="packageCostName">{item.name}</p>
                </div>
                <div className="costInfo">
                  <div className="">
                    <p className="costRange">Cost Range</p>
                    <p className="cost">{item.cost}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </AnimateHeight>

      <div className="showButtonContainer">
        {costInfo.length > 6 ? (
          <button
            className="showMoreCostInIndiaBtn"
            aria-expanded={height !== 0}
            aria-controls="example-panel"
            onClick={() => setHeight(height == 340 ? "auto" : 340)}
          >
            {" "}
            {height === 340 ? "Show More +" : "View Less"}
          </button>
        ) : null}
      </div>
    </div>
  );
}
